import { ProductTypeEnum } from '../enums/product-capture.enums';
import { DropDownOption } from '../interfaces/drop-down-option.interface';

export enum DownsideTypeEnum {
  NONE = 'NONE',
  PUT = 'PUT',
  KNOCK_IN_PUT = 'KNOCK_IN_PUT',
}

export const PARTICIPATION_DOWNSIDE_TYPE: DropDownOption[] = [
  { id: DownsideTypeEnum.NONE, displayValue: 'None' },
  { id: DownsideTypeEnum.PUT, displayValue: 'Put' },
  { id: DownsideTypeEnum.KNOCK_IN_PUT, displayValue: 'Knock-in Put' },
];

function getDownsideTypeItemsByIds(ids: DownsideTypeEnum[]): DropDownOption[] {
  return PARTICIPATION_DOWNSIDE_TYPE.filter((item) => ids.includes(item.id));
}

export const PRODUCT_DOWNSIDE_TYPES = new Map<
  ProductTypeEnum | '',
  DropDownOption[]
>([
  ['', PARTICIPATION_DOWNSIDE_TYPE],
  [
    ProductTypeEnum.DUAL_CURRENCY_NOTE,
    getDownsideTypeItemsByIds([
      DownsideTypeEnum.PUT,
      DownsideTypeEnum.KNOCK_IN_PUT,
    ]),
  ],
  [
    ProductTypeEnum.SUPERTRACKER,
    getDownsideTypeItemsByIds([
      DownsideTypeEnum.PUT,
      DownsideTypeEnum.KNOCK_IN_PUT,
    ]),
  ],
]);
